import { baseApi } from '../baseApi';
import { RolesModel } from '../../models/rolesModel';
import { cleanObject } from '../../utils/objectUtils';

export async function getRolesReq() {
  let url = '/officiating/person/role';
  return baseApi.get<RolesModel[]>(url);
}

export async function getRolesByIdReq(personId: string) {
  let url = '/officiating/person/role/other?';
  let queryParamsObj = cleanObject({
    personId,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get<RolesModel[]>(url + queryParams);
}

export async function updateRoleReq(role: RolesModel) {
  let url = '/officiating/person/role';

  return baseApi.put(url, { role });
}
